const htmlFontSize = 16;

export default {
  round,
  pxToRem,
  fontSize: 20,
  lineHeight: 7 / 6,
  label: {
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: 4 / 3,
  },
  caption: {
    fontSize: 16,
    fontWeight: 'normal',
  },
  body1: {
    fontSize: 20,
    fontWeight: 'normal',
  },
  body2: {
    fontSize: 24,
    fontWeight: 'normal',
  },
  title: {
    fontSize: 24,
    fontWeight: 'normal',
  },
  sectionTitle: {
    fontSize: 24,
    fontWeight: 'normal',
    marginBottom: 16,
    lineHeight: '2em',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
  },
  headline: {
    fontSize: 28,
    fontWeight: 'bold',
  },
  display1: {
    fontSize: 48,
    fontWeight: 'bold',
  },
  h1: {
    fontWeight: 'normal',
  },
  h2: {
    fontWeight: 'normal',
  },
  h3: {
    fontWeight: 'normal',
  },
  h4: {
    fontWeight: 'normal',
  },
  h5: {
    fontWeight: 'normal',
  },
  h6: {
    fontWeight: 'normal',
  },
};

export const typefaces = [
  {
    name: 'Courier New',
    type: 'mono',
  },
  {
    name: 'Georgia',
    type: 'serif',
  },
  {
    name: 'Lato',
    type: 'sans',
  },
  {
    name: 'Merriweather',
    type: 'serif',
  },
  {
    name: 'Open Sans',
    type: 'sans',
  },
  {
    name: 'Raleway',
    type: 'sans',
  },
  {
    name: 'Roboto',
    type: 'sans',
  },
  {
    name: 'Ubuntu',
    type: 'sans',
  },
];

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function pxToRem(value) {
  return `${value / htmlFontSize}rem`;
}

function getFontName(site) {
  return (site.styles && site.styles.font) || 'Roboto';
}

const fallbacks = {
  sans: 'Helvetica, Arial, sans-serif',
  serif: 'Georgia, Garamond, "Times New Roman", serif',
  mono: '"Lucida Console", "Courier New", monospace',
};

export function getFontFamily(site) {
  const font = getFontName(site);
  const fontType = typefaces.find(typeface => typeface.name === font).type;
  return `"${font}", ${fallbacks[fontType]}`;
}

export function loadFont(site) {
  if (typeof window !== 'undefined') {
    const WebFont = require('webfontloader');
    const fontName = getFontName(site)
      .split(' ')
      .join('+');
    WebFont.load({
      google: {
        families: [`${fontName}:400,700`],
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/site-render/src/SiteThemeProvider/typography.js